import { Component, OnInit } from '@angular/core';
// import {formatDate } from '@angular/common';

@Component({
  selector: 'app-psa-criminal-proceedings-list',
  templateUrl: './psa-criminal-proceedings-list.component.html',
  styleUrls: ['./psa-criminal-proceedings-list.component.css']
})
export class PsaCriminalProceedingsListComponent implements OnInit {
  title="List Of Employees With Criminal Proceedings";

 
  toDay ;
  constructor() {    
    this.toDay = new Date();
  }
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/home/psa-criminal-proceedings-list/psa-criminal-proceedings-list.component.ts